"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var widgets_1 = require("@tableau/widgets");
var Typography = widgets_1.TabStyles.Typography;
var interactiveLinkTextStyle = {
    fontSize: Typography.Sizing.Tiny,
    fontWeight: 'normal',
    color: Typography.Color.Primary,
};
var BentonLabelTextStyle = {
    boxSizing: 'border-box',
    fontSize: Typography.Sizing.Tiny,
    fontWeight: 'normal',
    color: Typography.Color.Secondary,
    lineHeight: '19px'
};
var TimeZoneDisplay = /** @class */ (function (_super) {
    __extends(TimeZoneDisplay, _super);
    function TimeZoneDisplay() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.InteractiveLinkExample = function () {
            var self = _this;
            return (React.createElement(widgets_1.InteractiveLinkWidget, {
                href: _this.props.timeZoneDetails.linkToUserSettings,
                onClick: function () {
                    window.top.location.href = self.props.timeZoneDetails.linkToUserSettings;
                },
                text: _this.props.timeZoneDetails.timeZoneDisplayName,
                testId: _this.props.testId,
            }));
        };
        return _this;
    }
    TimeZoneDisplay.prototype.render = function () {
        if (this.props.timeZoneDetails && this.props.timeZoneDetails.timeZonesEnabled) {
            return React.createElement(React.Fragment, null,
                React.createElement("div", { style: BentonLabelTextStyle }, this.props.label),
                React.createElement("div", { id: 'time-zone-display', "data-tb-test-id": this.props.testId, style: interactiveLinkTextStyle },
                    React.createElement(this.InteractiveLinkExample, null)));
        }
        else {
            return null;
        }
    };
    return TimeZoneDisplay;
}(React.Component));
exports.TimeZoneDisplay = TimeZoneDisplay;
//# sourceMappingURL=TimeZoneDisplay.js.map